export type FavouriteType = 'nav' | 'company' | 'individual' | 'task';

export interface FavouriteItem {
  id: string;
  type: FavouriteType;
  title: string;
  path: string;
  createdAt: number;
}

export const MAX_FAVOURITES = 20;

export const FAVOURITES_STORAGE_KEY_PREFIX = 'flightdeck-sidebar-favourites';
